import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Bunkerport(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const [formObj, setFormObj] = useState(FilterObj);
    const { globalfilter, screen, updateParent,reset, type } = props;
    const [bunkerportData, setBunkerportData] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const fetchBunkerPortData = async (event) => {
        
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/BunkerPort/${searchStr}`;

        await getRequest(url)
            .then((res) => {
               
                if (res.status == 200) {
                    let data   = res?.data || [];
                    let result = data?.map((a, i) => { 
                        return { id: a?.portName, name: a?.portName };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setBunkerportData(result);
                } else {
                    //ToastError(res.data.message);
                }
            })
            .catch((error) => {
                
                //ToastError(error.response.data.message);
            });
    }
    const handleChange=(event,newValue)=>{
        //
        props.onChange(newValue)
        const filteredFqtbunkerport = {
            ...formObj,
            Fqtbunkerport: newValue
        };
        setFormObj(filteredFqtbunkerport);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('FilterSetting'));
            Obj = {
                ...Obj,
                Fqtbunkerport: newValue
            }
            localStorage.setItem("FilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        ////
        let filtervalue = JSON.parse(localStorage.getItem('FilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Fqtbunkerport: filtervalue.Fqtbunkerport
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Fqtbunkerport);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Fqtbunkerport);
            console.log('getcookievalue',formObj)
        }else{
            setFormObj({});
        }
      }
      React.useEffect(() => {
        //
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                value={formObj?.Fqtbunkerport || []}
                getOptionSelected={(option, value) => option.name === value.name}
                options={bunkerportData}
                getOptionLabel={(option) =>option.name}
                //defaultValue={[top100Films[13]]}
                inputValue={filteredString}
                onChange={(event, newValue) => handleChange(event,newValue)}
               
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Bunker Port"
                        placeholder=""
                        onChange={fetchBunkerPortData}

                    />
                )}
            />
        


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
